import { Box, Typography, styled } from '@mui/material';
import { LINE, MUT2 } from './tokens';

export const CardRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'compact' && prop !== 'asChild',
})<{ compact?: boolean; asChild?: boolean }>(({ theme, compact, asChild }) => ({
  backgroundColor: theme.palette.background.paper,
  border: asChild ? 'none' : `1px solid ${LINE}`,
  borderRadius: compact ? '18px' : '22px',
  boxShadow: asChild
    ? 'none'
    : '0 24px 60px -24px rgba(20,57,92,.35), 0 1px 2px rgba(20,57,92,.05)',
  overflow: 'hidden',
  width: compact ? '440px' : '100%',
  maxWidth: '100%',
  ...theme.applyStyles('dark', {
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: '0 24px 60px -24px rgba(0,0,0,.5), 0 1px 2px rgba(0,0,0,.15)',
  }),
  // The fixed 440px compact width is meant for the dialog on desktop — on
  // mobile it's wider than the viewport, and (since the dialog wrapping it
  // sizes itself to fit-content) `maxWidth: 100%` alone can't shrink it
  // because a definite pixel width still drives the ancestor's intrinsic
  // sizing. Drop to 100% here so it takes whatever width the dialog gives it.
  ...(compact && { [theme.breakpoints.down('sm')]: { width: '100%' } }),
}));

export const Body = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
  padding: compact ? '18px 22px 22px' : '20px 34px 24px',
  [theme.breakpoints.down('sm')]: { padding: '16px' },
}));

export const FinePrint = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
  fontSize: '12.5px',
  lineHeight: 1.3,
  color: MUT2,
  textAlign: 'center',
  marginTop: compact ? '12px' : '10px',
  ...theme.applyStyles('dark', { color: theme.palette.text.secondary }),
  [theme.breakpoints.down('sm')]: { fontSize: '11px' },
}));
